<template>
  <div>
    <div class="app_bar">
      <div class="bar_item">
        <v-btn flat icon class="icon_button_normal" to="/">
          <v-icon>arrow_back</v-icon>
        </v-btn>
      </div>
      <div class="bar_item">
        <router-link :to="{ path: '/' }">
          <img src="@/assets/logo-banner.png" class="menu_icon" />
        </router-link>
      </div>
      <div class="spacer">
      </div>
      <div class="bar_item">
        <v-btn
          flat
          icon
          class="icon_button_normal"
          href="https://media.brainingcamp.com/static/pdfs/brainingcamp-wcag-keyboard-shortcuts.pdf"
          target="_blank"
        >
          <v-icon>keyboard</v-icon>
        </v-btn>
      </div>
      <div class="bar_item">
        <v-btn
          flat
          icon
          class="icon_button_normal"
          :to="{ path: '/tutorials' }"
          target="_blank"
        >
          <v-icon>ondemand_video</v-icon>
        </v-btn>
      </div>
      <div class="bar_item" v-if="!isStudent">
        <v-btn
          depressed
          color="gold"
          href="https://forms.gle/RtB3qVA4FjgeFDtC7"
          target="_blank"
        >
          <v-icon small>chat</v-icon>
          &nbsp;Feedback
        </v-btn>
      </div>
      <div class="bar_item" v-if="!isStudent">
        <v-btn
          depressed
          dark
          color="magenta"
          v-on:click="showLiveDialog = true"
        >
          <v-icon>connect_without_contact</v-icon>
          &nbsp;LIVE
        </v-btn>
      </div>
      <div class="bar_item">
        <v-btn
          depressed
          dark
          color="secondary"
          v-on:click="showShareDialog = true"
        >
          <v-icon style="transform: rotateY(180deg);">reply</v-icon>
          &nbsp;Share
        </v-btn>
      </div>
    </div>
    <div class="m_app">
      <div id="manipulative_viewer" class="manipulative_viewer">
        <div id="manip_wrapper_parent">
          <div id="manip_wrapper" tabindex="0">
            <div id="manip_div" class="manipulative_container">
              <v-layout
                wrap
                justify-center
                align-center
                v-if="initializing"
                pa-0
              >
                <v-flex
                  xs12
                  id="buffer_cell"
                  style="height: 240px"
                >
                </v-flex>
                <v-flex xs12 text-xs-center title>
                  {{ loadMessage }}
                </v-flex>
                <v-flex xs6>
                  <v-progress-linear
                    color="secondary"
                    :height="40"
                    v-model="loadProgress"
                  >
                  </v-progress-linear>
                </v-flex>
              </v-layout>
              <v-layout
                wrap
                justify-center
                align-center
                v-if="initError"
                py-3
              >
                <v-flex xs12 error-block pa-5 text-xs-center>
                  <p class="headline secondary--text mb-3">
                    Sorry, could not load the manipulative.
                  </p>
                  <p class="subheading primary--text mb-3">
                    This feature may not be supported by
                    older browsers or operating systems.
                    Please try again on a different browser
                    or operating system. Contact
                    support@brainingcamp.com if the problem
                    continues.
                  </p>
                  <p class="caption red--text">
                    {{ initError }}
                  </p>
                </v-flex>
              </v-layout>
            </div>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="displayShareCode" width="600">
      <v-layout wrap white pa-3>
        <v-flex xs12>
          <v-layout>
            <v-flex xs4>
              <v-text-field
                readonly
                label="Share Code"
                v-model="shareCode"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex pt-1>
              <v-btn
                flat
                small
                fab
                color="primary"
                v-on:click="copyButtonPressed(shareCode)"
              >
                <v-icon x-large>content_copy</v-icon>
              </v-btn>
              <v-btn
                flat
                small
                fab
                color="primary"
                v-on:click="
                    displayLargeShareCode = true;
                    displayShareCode = false;
                "
              >
                <v-icon x-large>zoom_in</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
          <v-layout>
            <v-flex>
              <v-text-field
                readonly
                label="Link"
                v-model="shareLink"
                outline
              ></v-text-field>
            </v-flex>
            <v-flex xs3 pt-1>
              <v-btn
                flat
                small
                fab
                color="primary"
                v-on:click="copyButtonPressed(shareLink)"
              >
                <v-icon x-large>content_copy</v-icon>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-flex>
        <v-flex caption>
          <ul>
            <li>You must be a logged in to use a Share Code or link.</li>
            <li>Share Codes can be entered in the Share Code box on the main page.</li>
            <li>To learn more about Share Codes, click <router-link :to="{ path: '/tutorials' }">here</router-link>.</li>
          </ul>
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="displayLargeShareCode" width="600">
      <v-layout wrap white pa-3>
        <v-flex headline xs12 text-xs-center mb-3>
          Share Code:
        </v-flex>
        <v-flex
          xs12
          display-3
          secondary--text
          text-xs-center
          v-if="shareCode"
        >
          {{ shareCode }}
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-snackbar
      v-model="copyToClipboadFailed"
      :timeout="10000"
      top="top"
      color="red darken-2"
    >
      Could not access the Clipboard.
      <v-icon color="white" v-on:click="copyToClipboadFailed = false">
        close
      </v-icon>
    </v-snackbar>

    <v-snackbar
      v-model="copyToClipboadSuccess"
      :timeout="4000"
      top="top"
      color="green lighten-1"
    >
      Copied to Clipboard!
      <v-icon
        color="white"
        v-on:click="copyToClipboadSuccess = false"
      >
        close
      </v-icon>
    </v-snackbar>

    <v-dialog v-model="showClipboardFallback" :width="dialogWidth">
      <v-layout wrap white pa-3>
        <v-flex
          xs12
          text-xs-center
          secondary--text
          body-2
          px-5
          py-3
        >
          To copy to the clipboard, right-click on the image and select "Copy Image".
        </v-flex>
        <v-flex xs12 elevation-5>
          <img id="clipboardFallbackImage" width="100%" />
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="invalidCodeError" width="550">
      <v-layout wrap white pa-3>
        <v-flex xs12 headline text-xs-center primary--text pa-3>
          Not a recognized code. Please try again.
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="invalidFileError" width="550">
      <v-layout wrap white pa-3>
        <v-flex xs12 headline text-xs-center primary--text pa-3>
          Could not load. Please try again.
        </v-flex>
      </v-layout>
    </v-dialog>

    <v-dialog v-model="fileLoadError" width="550">
      <v-layout wrap white pa-3>
        <v-flex xs12 headline text-xs-center primary--text pa-3>
          There was a problem loading the file. The error has been sent to our support team.
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="showLiveDialog" width="600">
      <v-layout wrap white pa-3 text-xs-center>
        <v-flex xs12 mt-3>
          <p style="font-weight: 600; font-size: 24px; color: #072846">Start a LIVE session?</p>
        </v-flex>
        <v-flex xs12 pa-3>
          <p>Use LIVE to collaborate and watch students work in real-time.</p>
        </v-flex>
        <v-flex text-xs-center py-3 v-if="generatingLiveSession">
          <v-progress-circular
            size="24"
            width="4"
            indeterminate
            color="magenta"
          ></v-progress-circular>
        </v-flex>
        <v-flex v-else>
          <v-btn
            depressed
            dark
            large
            color="magenta"
            v-on:click="createLiveSession"
          >
            <v-icon>connect_without_contact</v-icon>
            &nbsp;Start
          </v-btn>
        </v-flex>
      </v-layout>
    </v-dialog>
    <v-dialog v-model="showShareDialog" width="600">
      <ShareDialog
        :showLiveOption="false"
        :connectingToShareService="generatingShareCode"
        :showShareError="shareCreationError"
        :connectingToLiveService="generatingLiveSession"
        :showLiveError="liveCreationError"
        @createShare="generateShareCode"
        @startLive="createLiveSession"
        @download="downloadImage"
        @copy="copyImage"
        @close="showShareDialog = false"
      />
    </v-dialog>
    <v-dialog v-model="showLiveLauncher" max-width="400">
      <v-layout wrap white pa-5>
        <v-flex xs12 headline text-xs-center mb-3>
          <v-icon x-large color="accent" class="custom-fab">connect_without_contact</v-icon>
        </v-flex>
        <v-flex xs12 title text-xs-center mb-3>
          LIVE session is ready!
        </v-flex>
        <v-flex xs12 text-xs-center>
          <a
            :href="liveURI"
            target="_blank"
            @click="showLiveLauncher = false"
          >
            <v-btn color="accent" large>Go</v-btn>
          </a>
        </v-flex>
      </v-layout>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import store from '@/store.js';
import { debounce, find } from 'lodash';
import manips from '@/data/manips.js';
import AuthorizeService from '@/services/AuthorizeService';
import ShareService from '@/services/ShareService';
import ShareDialog from '@/components/dialogs/ShareDialog';

const kSIDEBAR_WIDTH = 0;
const kTOOLBAR_HEIGHT = 48;

export default {
    static: {
        app: null
    },
    components: {
        ShareDialog
    },
    data: function() {
        return {
            containerId: 'manip_div',
            initializing: false,
            loadMessage: '',
            loadProgress: 0,
            dialogWidth: 400,
            config: null,
            initError: null,
            invalidCodeError: false,
            invalidFileError: null,
            fileLoadError: false,
            generatingShareCode: false,
            shareCode: null,
            displayShareCode: false,
            displayLargeShareCode: false,
            shareCreationError: false,
            copyToClipboadSuccess: false,
            copyToClipboadFailed: false,
            showClipboardFallback: false,
            showShareDialog: false,
            showLiveDialog: false,
            generatingLiveSession: false,
            liveCreationError: false,
            liveURI: null,
            showLiveLauncher: false
        };
    },
    methods: {
        createLiveSession: async function() {
            this.generatingLiveSession = true;
            this.liveCreationError = false;
            const app = this.$options.static.app;

            try {
                const s = app.save();
                const requestOptions = {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ manipFile: JSON.stringify(s) })
                };

                const response = await fetch(
                    'https://api.live.brainingcamp.com/live/api/sessions',
                    requestOptions
                );

                if (response.ok) {
                    const data = await response.json();
                    this.liveURI = data.redirectUri;
                    this.showLiveLauncher = true;
                    this.showShareDialog = false;
                    this.showLiveDialog = false;
                }
            } catch (err) {
                this.liveCreationError = true;
            }
            this.generatingLiveSession = false;
        },
        generateShareCode: async function() {
            this.generatingShareCode = true;
            this.shareCreationError = false;
            const app = this.$options.static.app;
            // post a new save tagged as a share
            this.shareCode = null;
            try {
                const s = app.save();
                const result = await ShareService.post(s);

                this.shareCode = result.data.code;
                this.displayShareCode = true;
                this.showShareDialog = false;
            } catch (err) {
                this.shareCreationError = true;
            }
            this.generatingShareCode = false;
        },
        getScrollbarWidth: function() {
            try {
                var tw = window.innerWidth - kSIDEBAR_WIDTH;
                var cw = document.body.clientWidth - kSIDEBAR_WIDTH;

                return tw - cw;
            } catch (err) {
                return 0;
            }
        },
        resizer: debounce(function() {
            const app = this.$options.static.app;
            var sbw = this.getScrollbarWidth();

            var w = window.innerWidth - kSIDEBAR_WIDTH - sbw;
            var h = window.innerHeight - kTOOLBAR_HEIGHT;
            var div = app.rootDiv;
            //set dimensions
            div.style.transform = '';
            div.style.marginLeft = '';
            div.style.marginTop = '';
            div.style.width = w + 'px';
            div.style.height = h + 'px';
            app.canvas.width = w;
            app.canvas.height = h;

            //redraw
            app.redraw();
        }, 32),
        copyButtonPressed: function(textToCopy) {
            var t = document.createElement('textarea');
            t.value = textToCopy;
            t.className = 'copy-item';

            // add the element
            document.body.appendChild(t);

            // select and copy
            t.focus();
            t.select();

            try {
                var status = document.execCommand('copy');
            } catch (err) {
                console.error('unable to copy', err);
            }

            // cleanup
            document.body.removeChild(t);
            this.copyToClipboadSuccess = true;
        },
        copyImage: async function(e) {
            const app = this.$options.static.app;
            const canvas = app.canvas;

            var copyResult = null;
            var needsClipboardFallback = false;
            try {
                // chrome version
                const blob = await new Promise((resolve) =>
                    canvas.toBlob(resolve)
                );

                const item = [new ClipboardItem({ 'image/png': blob })];

                await navigator.clipboard.write(item);

                copyResult = true;
            } catch (error) {
                console.log(error);
                needsClipboardFallback = true;
            }

            if (needsClipboardFallback) {
                // const imgData = canvas.toDataURL();
                const imgData = app.toDataURL();

                var img = document.getElementById('clipboardFallbackImage');
                img.src = imgData;

                this.showClipboardFallback = true;
                return;
            }
            if (copyResult) {
                this.copyToClipboadSuccess = true;
                this.copyToClipboadFailed = false;
            } else {
                this.copyToClipboadSuccess = false;
                this.copyToClipboadFailed = true;
            }

            // holder.removeChild(canvas);
            this.showShareDialog = false;
        },
        downloadImage: function(e) {
            const app = this.$options.static.app;
            const imgData = app.toDataURL();

            var a = document.createElement('a');
            a.href = imgData;
            a.download = 'screenshot.png';
            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);

            this.showShareDialog = false;
        },
        stateLoadFailedEventHandler: function(e) {
            const shareCode = this.$route.params.shareCode;
            const errors = e.detail.error;
            var payload = {
                level: 'warning',
                user: {
                    id: store.getters.user.id
                },
                tags: {
                    service: 'share',
                    source: 'bcm',
                    event: 'state_load_failed'
                },
                extra: {
                    errors: errors.map((err) => err.message)
                }
            };
        }
    },
    mounted: async function() {
        document.addEventListener(
            'state_load_failed',
            this.stateLoadFailedEventHandler
        );

        this.initializing = true;
        this.loadProgress = 0;
        this.loadMessage = 'Initializing ...';
        
        var license = "*";
        const m_id = this.$route.params.manip_name;
        var authorized = false;
        
        if (license === "*" || m_id === license) {
          authorized = true;
        }
        this.hasBundle = license === '*'

        if (!authorized) {
          this.$router.push({
            path: '/'
          })
        }

        // setup geometry
        var sbw = this.getScrollbarWidth();
        var width = window.innerWidth - kSIDEBAR_WIDTH - sbw;
        var height = window.innerHeight;

        // Has license rights, get the config for the manipulative
        this.config = find(manips, { id: m_id });
        this.loadProgress = 30;
        this.loadMessage = 'Setting Up ...';

        // Create an instance of the manipulative. catch any errors when creating an instance and report as a outdated browser issue
        let appletInstance = null;
        let options = {
            appId: m_id,
            width: width,
            height: height,
            state: null,
            enableKeyboardListeners: true
        };

        let fileToLoad = null;

        const shareCode = this.$route.params.shareCode;

        if (shareCode) {
            try {
                const result = await ShareService.get(shareCode);

                var file = result.data.payload;

                this.config = find(manips, { id: m_id });

                if (file.appId === m_id) {
                    fileToLoad = file;
                } else {
                    // if the share code is valid but is for the wrong manipulative, just show the invalid file error
                    this.invalidFileError = true;
                    fileToLoad = null;
                }
            } catch (err) {
                // if the share code isn't valid, just show the invalid file error
                this.invalidCodeError = true;
                fileToLoad = null;
            }
        }

        this.loadProgress = 75;
        this.loadMessage = 'Rendering ...';

        if (fileToLoad) {
            options.width = fileToLoad.width;
            options.height = fileToLoad.height;
            options.state = fileToLoad.state;
        }

        try {
            appletInstance = new bcm.BcmApplet(this.containerId);
            await appletInstance.load(options.appId, options);
        } catch (err) {
            // display a unable to initialize error (most likely outdated browser)
            this.initError = err;
        }

        if (this.initError) {
            this.initializing = false;
            return;
        }

        // setup the resizer
        window.addEventListener('resize', this.resizer);

        this.$options.static.app = appletInstance;

        // update viewer
        this.loadProgress = 100;
        this.loadMessage = 'Done!';

        this.initializing = false;

        // make sure there is no scrolling and that the viewer matches the canvas dimensions
        this.resizer();

        try {
            const authResult = await AuthorizeService.authorize(m_id, this.userRole);
        } catch (err) {
            console.log(err);
        }
    },
    beforeRouteLeave(to, from, next) {
        try {
            const app = this.$options.static.app;

            if (app) {
                app.unload();
                this.$options.static.app = null;
            }

            window.removeEventListener('resize', this.resizer);
        } catch (e) {
            console.log(e);
        }

        next();
    },
    computed: {
      isStudent: function () {
        if (this.$store.getters.role) {
          return this.$store.getters.role === 'student';
        }
        return false;
      },
      shareLink: function() {
        if (this.shareCode) {
          return location.origin + '/s/' + this.shareCode;
        }
        return '';
      },
      userRole: function () {
        if (this.$store.getters.role) {
          return this.$store.getters.role;
        }
        return '';
      }
    }
};
</script>

<style scoped>
body {
    overflow: hidden;
}

.custom-fab {
    width: 70px;
    height: 70px;
    background-color: #fbeee9;
    border-radius: 35px;
}

.hide {
    display: none;
}

.show {
    display: block;
}

.error-block {
    width: 100%;
    height: 100%;
    grid-area: viewer;
    text-align: center;
}

.manipulative_viewer {
    overflow: hidden;
    background: #cecece;
    width: 100%;
    height: calc(100vh - 48px);
    display: grid;
    grid-template-columns: auto;
    grid-template-areas: 'viewer';
}

.menu_icon {
    padding-top: 6px;
    height: 34px;
}

.manipulative_container {
    grid-area: viewer;
    transform-origin: top left;
}

.v-overlay--active:before {
    opacity: 0.98;
}

.v-dialog:not(.v-dialog--fullscreen) {
    max-height: 100%;
}

.copy-input-style {
    position: absolute;
    left: -100;
}

#manip_wrapper {
    outline: none;
}

#manip_div {
    width: 100vw;
    height: calc(100vh - 48px);
}

.icon_button_normal {
    color: #616161;
    background-color: #f5f5f5;
}

.icon_button_emphasized {
    color: white;
    background-color: #3296f3;
}

.toolbar_text_btn {
    width: auto;
    height: 36px;
    color: white;
}

.toolbar_text_btn {
    height: 34px !important;
    border-radius: 6px;
    padding: 8px 8px !important;
    font-family: Poppins;
    font-weight: 600;
    font-size: 16px;
    margin-left: 12px !important;
    text-transform: capitalize !important;
    color: white;
    background-color: #3296f3 !important;
}

.toolbar_feedback_btn {
    height: 34px !important;
    border-radius: 6px;
    padding: 8px 8px !important;
    font-family: Poppins;
    font-weight: 600;
    font-size: 16px;
    text-transform: capitalize !important;
    color: black;
    background-color: #FFC107 !important;
}

.toolbar_text_btn:hover {
    background-color: #3296f3 !important;
}

.toolbar_text_btn:focus {
    background-color: #3296f3 !important;
}

.app_bar {
  position: fixed;
  height: 48px;
  left: 0;
  right: 0;
  top: 0;
  background: white;
  display: flex;
  box-shadow: 0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important;
  z-index: 1000;
}

.app_bar .spacer {
  flex-grow: 1;
}

.m_app {
  position: fixed;
  top: 48px;
  left: 0;
  right: 0;
  bottom: 0;
  touch-action: none;
}

</style>
